import controller from './kform-tree.controller';
import template from './kform-tree.html';

export default {
	bindings: {
		selectedForm: '<',
		forms:        '<',
	},
	controller,
	template,
	require: {
		kform: '^^kform',
	},
};
